import { Pipe, PipeTransform } from '@angular/core';
import {
  CalendarStatusEnum,
  CalendarStatusInfo,
} from '@qaroni-app/schedule/types/calendar-status.enum';

@Pipe({
  name: 'calendarStatus',
  standalone: false,
})
export class CalendarStatusPipe implements PipeTransform {
  transform(value: CalendarStatusEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(CalendarStatusInfo, value)
    ) {
      return CalendarStatusInfo[value].name;
    }

    return value;
  }
}
